import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Select,
  Button,
  Table,
  Popconfirm,
  Tooltip,
  Input,
  Modal,
  Form,
  DatePicker,
  Card,
  InputNumber,
  Tag,
  Radio,
  Space,
  Dropdown,
  Menu,
  notification,
  Popover,
  Checkbox,
} from "antd";
import "../Pages/CSS/DonnesBases.css";
import "../Pages/CSS/Traitement.css";
import { BpiService } from "../Services/BpiService";
import * as XLSX from "xlsx";
import {
  CalculatorOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  CheckSquareOutlined,
  CloseSquareOutlined,
  DeleteFilled,
  DownOutlined,
  EditOutlined,
  MoreOutlined,
  PlusOutlined,
  SyncOutlined,
  UndoOutlined,
  FileTextOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import FacturePdf from "./FacturePdf";
import { AdherentsService } from "../Services/AdherentsService";
import "moment/locale/fr";
import moment from "moment";
import dayjs from "dayjs";
import { ExerciceDocService } from "../Services/ExerciceDocService";
import Draggable from "react-draggable";
import { ReglementsService } from "../Services/ReglementsService";
moment.locale("fr");
const { Option } = Select;
const { confirm } = Modal;

const DraggableModal = ({ children, ...props }) => {
  const [disabled, setDisabled] = useState(true);
  const draggleRef = useRef(null);

  return (
    <Modal
      {...props}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={draggleRef.current ? draggleRef.current : undefined}
          handle=".ant-modal-title"
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
      title={
        <div
          className="ant-modal-title"
          style={{ width: "100%", cursor: "move" }}
          onMouseOver={() => setDisabled(false)}
          onMouseOut={() => setDisabled(true)}
        >
          {props.title}
        </div>
      }
    >
      {children}
    </Modal>
  );
};

const FactureAdht = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [adherents, setAdherents] = useState([]);
  const [selectAdherent, setSelectAdherent] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);
  const [years, setYears] = useState([]);
  const [currentFacture, setCurrentFacture] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedOption, setSelectedOption] = useState("NP");
  const [isEditingEnabled, setIsEditingEnabled] = useState(false);
  const [isRgFactEnabled, setIsRgFactEnabled] = useState(false);
  const [isComptaEnabled, setIsComptaEnabled] = useState(false);
  const [isAnRegEnabled, setIsAnRegEnabled] = useState(false);
  const [isAnPayeEnabled, setIsAnPayeEnabled] = useState(false);
  const [isPayingEnabled, setIsPayingEnabled] = useState(false);
  const [isOtherButtonsEnabled, setIsOtherButtonsEnabled] = useState(false);
  const [isMassTransferEnabled, setIsMassTransferEnabled] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [journalRegData, setJournalRegData] = useState([]);
  const [paramsDetails, setParamsDetails] = useState(null);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [selectedTypeReglement, setSelectedTypeReglement] = useState(null);
  const [isTypeRegDisabled, setIsTypeRegDisabled] = useState(false);
  const [solde, setSolde] = useState(0);
  const [isEditMode, setIsEditMode] = useState(false);
  const getSelectedYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear.toString();
  };
  const [selectedYear, setSelectedYear] = useState(getSelectedYear());
  const [filteredData, setFilteredData] = useState([]);
  const [montantNet, setMontantNet] = useState(0);

  const getSelectedMonth = () => {
    const currentMonth = new Date().getMonth() + 1;
    return currentMonth.toString();
  };
  const [selectedMonth, setSelectedMonth] = useState(getSelectedMonth());

  const months = [
    { value: "1", label: "Janvier" },
    { value: "2", label: "Février" },
    { value: "3", label: "Mars" },
    { value: "4", label: "Avril" },
    { value: "5", label: "Mai" },
    { value: "6", label: "Juin" },
    { value: "7", label: "Juillet" },
    { value: "8", label: "Août" },
    { value: "9", label: "Septembre" },
    { value: "10", label: "Octobre" },
    { value: "11", label: "Novembre" },
    { value: "12", label: "Décembre" },
  ];

  const exerciceDocService = new ExerciceDocService();
  const adherentsService = new AdherentsService();
  const reglementService = new ReglementsService();
  const bpiService = new BpiService();
  const [form] = Form.useForm();

  useEffect(() => {
    setLoading(true);
    bpiService
      .getAllFacSoc(selectedYear, selectedMonth)
      .then((data) => {
        setTableData(data);

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, [refreshTable, selectedYear, selectedMonth]);

  useEffect(() => {
    const filtered = selectAdherent
      ? tableData.filter((item) => item.codesoc === selectAdherent)
      : tableData;
    setFilteredData(filtered);
  }, [tableData, selectAdherent]);

  const handleRefresh = () => {
    setRefreshTable(!refreshTable);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const yearsData = await exerciceDocService.getAllExercicesDoc();
        setYears([...yearsData].sort((a, b) => b - a));
        // await fetchDataByOption(selectedOption);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, []);

  const handleDeleteline = async (num_facture) => {
    try {
      confirm({
        title: "Êtes-vous sûr de vouloir supprimer cette prestation ?",
        okText: "Oui",
        cancelText: "Non",
        onOk: async () => {
          try {
            await bpiService.deleteFac(num_facture);
            const updatedData = filteredData.filter(
              (item) => item.num_facture !== num_facture
            );
            setFilteredData(updatedData);
          } catch (error) {
            console.error("Erreur lors de la suppression du document :", error);
          }
        },
        onCancel() {
          // Annulation
        },
      });
    } catch (error) {
      console.error(
        "Erreur lors de la confirmation de la suppression :",
        error
      );
    }
  };

  function formatNumber(number) {
    return new Intl.NumberFormat("fr-FR").format(number);
  }

  //Filtre recherche
  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Mettre à jour les données filtrées
  };

  const fetchAdherents = async () => {
    try {
      const adherentsData = await adherentsService.getAllAdherents();
      setAdherents(adherentsData);
    } catch (error) {
      console.error("Erreur lors de la récupération des adhérents :", error);
    }
  };

  useEffect(() => {
    fetchAdherents();
  }, []);

  const fetchSaisie = async (type) => {
    try {
      const journalsData = await reglementService.getSaisieReg();
      setJournalRegData(journalsData);
      /* setTypeReglementFourn(
          journalsData.filter((journal) => journal.type === type)
        ); */
    } catch (error) {
      notification.error({
        message: "Erreur lors de la récupération des journaux comptables",
        description: error.message,
      });
    }
  };

  const loadParams = async () => {
    try {
      const data = await reglementService.getParamReg();
      setParamsDetails(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des données", error);
    }
  };
  /*  useEffect(() => {
        loadParams();
      }, []); */

  useEffect(() => {
    if (paramsDetails && paramsDetails.datedeb) {
      setSelectedDate(dayjs(paramsDetails.datedeb));
    } else {
      setSelectedDate(dayjs());
    }
  }, [paramsDetails]);

  useEffect(() => {
    form.setFieldsValue({
      datetrait: selectedDate.format("MMM-YYYY"),
    });
  }, [selectedDate, form]);

  const onchangeAdhenrent = (value) => {
    setSelectAdherent(value);
  };

  const exportToExcel = () => {
    const dataToExport = filteredData.map((item) => ({
      "Code soc.": item.codesoc,
      Société: item.societe,
      Date: item.date_facture,
      "N° facture": item.num_facture,
      Période: item.periode,
      "Nb. Part.": item.nb_participants,
      "Montant cotis.": item.montant_cotis,
      "Montant FM": item.montant_fm,
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Factures");

    XLSX.writeFile(wb, "factures.xlsx");
  };

  /*  const showModal = (record = null) => {
    fetchAdherents();
    if (record) {
      form.setFieldsValue({
        codesoc: record.codesoc,
        date_facture: dayjs(moment(record.date_facture)),
        date_envoie: dayjs(moment(record.date_envoie)),
        montant_cotis_pat: record.montant_cotis_pat,
        montant_cotis_sal: record.montant_cotis_sal,
        montant_fm: record.montant_fm,
        montant_adh: record.montant_adh,
        montant_sub: record.montant_sub,
        montant_net:record.montant_net,
        periode: dayjs(moment(record.periode)),
        nb_participants: record.nb_participants,
      });
    
      setCurrentFacture(record);
    } else {
      form.resetFields();
      form.setFieldsValue({
        date_facture: dayjs(moment()), // Date d'aujourd'hui
        periode: dayjs(moment()), // Date d'aujourd'hui
      });
      setCurrentFacture(null);
    }
    setIsModalVisible(true);
  }; */
  const showModal = (record = null) => {
    fetchAdherents();
    if (record) {
      form.setFieldsValue({
        codesoc: record.codesoc,
        date_facture: dayjs(moment(record.date_facture)),
        date_envoi: dayjs(moment(record.date_envoi)),
        montant_cotis_pat: record.montant_cotis_pat ?? 0,
        montant_cotis_sal: record.montant_cotis_sal ?? 0,
        montant_fm: record.montant_fm ?? 0,
        montant_adh: record.montant_adh ?? 0,
        montant_sub: record.montant_sub ?? 0,
        montant_net: record.montant_net ?? 0,
        periode: dayjs(moment(record.periode)),
        nb_participants: record.nb_participants ?? 0, // Si le nombre de participants est vide, affiche 0
      });

      setCurrentFacture(record);
    } else {
      form.resetFields();
      form.setFieldsValue({
        date_facture: dayjs(moment()), // Date d'aujourd'hui
        date_envoi: dayjs(moment()),
        periode: dayjs(moment()), // Date d'aujourd'hui
        montant_cotis_pat: 0,
        montant_cotis_sal: 0,
        montant_fm: 0,
        montant_adh: 0,
        montant_sub: 0,
        montant_net: 0,
        nb_participants: 0,
      });
      setCurrentFacture(null);
    }
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    form.resetFields();
    setCurrentFacture(null);
    setIsModalVisible(false);
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);
  };

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
  };
  const stateConfig = {
    NP: {
      isEditingEnabled: true,
      isPayingEnabled: true,
      isMassTransferEnabled: false,
      isComptaEnabled: false,
      isAnPayeEnabled: false,
      isAnRegEnabled: false,
      isRgFactEnabled: false,
    },
    AP: {
      isEditingEnabled: true,
      isPayingEnabled: false,
      isMassTransferEnabled: true,
      isComptaEnabled: false,
      isAnPayeEnabled: true,
      isAnRegEnabled: false,
      isRgFactEnabled: true,
      isOtherButtonsEnabled: true,
    },
    PP: {
      isEditingEnabled: true,
      isPayingEnabled: false,
      isMassTransferEnabled: true,
      isComptaEnabled: true,
      isAnPayeEnabled: false,
      isAnRegEnabled: false,
      isRgFactEnabled: false,
    },
    CC: {
      isEditingEnabled: true,
      isPayingEnabled: false,
      isMassTransferEnabled: true,
      isComptaEnabled: false,
      isAnPayeEnabled: false,
      isAnRegEnabled: true,
      isRgFactEnabled: false,
    },
    NN: {
      isEditingEnabled: true,
      isPayingEnabled: true,
      isMassTransferEnabled: true,
      isComptaEnabled: false,
      isAnPayeEnabled: false,
      isAnRegEnabled: false,
      isRgFactEnabled: false,
    },
  };

  const handleOptionChange = (e) => {
    const newOption = e.target.value;
    setSelectedOption(newOption);
    setSelectedRowKeys([]); // Réinitialiser la sélection des lignes
    setIsEditingEnabled(false);
    setIsPayingEnabled(false);
    setIsMassTransferEnabled(false);
    setIsComptaEnabled(false);
    setIsAnPayeEnabled(false);
    setIsAnRegEnabled(false);
    setIsRgFactEnabled(false);
    setIsOtherButtonsEnabled(false);
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);

    const hasSelectedRows = newSelectedRowKeys.length > 0;
    if (hasSelectedRows) {
      const selectedState = stateConfig[selectedOption] || {};
      setIsEditingEnabled(selectedState.isEditingEnabled);
      setIsPayingEnabled(selectedState.isPayingEnabled);
      setIsMassTransferEnabled(selectedState.isMassTransferEnabled);
      setIsComptaEnabled(selectedState.isComptaEnabled);
      setIsAnPayeEnabled(selectedState.isAnPayeEnabled);
      setIsAnRegEnabled(selectedState.isAnRegEnabled);
      setIsRgFactEnabled(selectedState.isRgFactEnabled);
      setIsOtherButtonsEnabled(selectedState.isOtherButtonsEnabled);
    } else {
      setIsEditingEnabled(false);
      setIsPayingEnabled(false);
      setIsMassTransferEnabled(false);
      setIsComptaEnabled(false);
      setIsAnPayeEnabled(false);
      setIsAnRegEnabled(false);
      setIsRgFactEnabled(false);
      setIsOtherButtonsEnabled(false);
    }
  };

  const allRowKeys = filteredData.map((record) => record.num_facture);

  const handleSelectAllChange = (e) => {
    setSelectedRowKeys(e.target.checked ? allRowKeys : []);
  };

  const rowSelection = {
    selectedRowKeys,
    columnTitle: (
      <Checkbox
        checked={allRowKeys.length > 0 && selectedRowKeys.length === allRowKeys.length}
        indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < allRowKeys.length}
        onChange={handleSelectAllChange}
      />
    ),
    onChange: onSelectChange, // Utilisation de la fonction nommée

    selections: [
      {
        key: "select-all",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CheckSquareOutlined style={{ color: "#52c41a" }} />
            Sélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          const allKeys = filteredData.map((item) => item.num_facture);
          setSelectedRowKeys(allKeys);
          onSelectChange(allKeys); // Appel explicite pour inclure la logique de validation
        },
      },
      {
        key: "clear-selection",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CloseSquareOutlined style={{ color: "#ff4d4f" }} />
            Désélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          setSelectedRowKeys([]);
          onSelectChange([]); // Appel explicite avec un tableau vide
        },
      },
    ],

    getCheckboxProps: (record) => ({
      name: record.num_facture,
    }),
  };
  const handleTypeReglementChange = (value) => {
    setSelectedTypeReglement(value);
  };
  const typeReglementLabels = {
    V: "Virement",
    C: "Chèque",
    Compte: "Compte Avance",
    E: "Espèce",
    T: "Transfert",
  };
  const handleModalCancel = () => {
    setModalVisible(false);

    setSelectedTypeReglement(null);
    form.resetFields(["typeReg", "numReg", "comptegen"]);
    setSolde(0);
  };

  const handleModalOk = async () => { };

  const onFinish = async (values) => {
    const docData = {
      ...values,
      periode: dayjs(values.periode.format("YYYY-MM-DD")),
      montant_net: montantNet,
    };

    if (currentFacture) {
      // Mise à jour
      docData.num_facture = currentFacture.num_facture;
      try {
        await bpiService.FacEditDoc(docData);
        console.log("Document modifié avec succès");
        // Fermer le modal et rafraîchir les données
        handleCancel();
        setRefreshTable(!refreshTable);
        //   setReloadData(!reloadData);
      } catch (error) {
        console.error("Erreur lors de la modification du document :", error);
      }
    } else {
      // Ajout
      try {
        await bpiService.FacAddDoc(docData);
        console.log("Document ajouté avec succès");
        // Fermer le modal et rafraîchir les données
        handleCancel();
        setRefreshTable(!refreshTable);
        // setReloadData(!reloadData); // Ou toute autre logique de rafraîchissement
      } catch (error) {
        console.error("Erreur lors de l'ajout du document :", error);
      }
    }
  };
  const calculateMontantNet = () => {
    const values = form.getFieldsValue([
      "montant_cotis_pat",
      "montant_cotis_sal",
      "montant_fm",
      "montant_adh",
      "montant_sub",
    ]);

    const montantNetCalc = Object.values(values).reduce(
      (acc, value) => acc + (parseFloat(value) || 0),
      0
    );

    setMontantNet(montantNetCalc); // Met à jour l'affichage
    form.setFieldsValue({ montant_net: montantNetCalc }); // Met à jour le formulaire
  };

  useEffect(() => {
    calculateMontantNet();
  }, [
    form.getFieldValue("montant_cotis_pat"),
    form.getFieldValue("montant_cotis_sal"),
    form.getFieldValue("montant_fm"),
    form.getFieldValue("montant_adh"),
    form.getFieldValue("montant_sub"),
  ]);

  const columns = [
    {
      title: "N° facture",
      dataIndex: "num_facture",
      key: "num_facture",
      align: "center",
      sorter: (a, b) =>
        (a.num_facture || "").localeCompare(b.num_facture || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Code soc.",
      dataIndex: "codesoc",
      key: "codesoc",
      align: "center",
      render: (text) => <strong>{text || "N/A"}</strong>, // Gérer les valeurs null ou undefined
      sorter: (a, b) => (a.codesoc || "").localeCompare(b.codesoc || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Adhérent",
      dataIndex: "societe",
      key: "societe",
      sorter: (a, b) => (a.societe || "").localeCompare(b.societe || ""),
      sortDirections: ["ascend", "descend"],
      render: (text) => <span>{text || "N/A"}</span>, // Gérer les valeurs null ou undefined
    },
    {
      title: "Date Facture",
      dataIndex: "date_facture",
      key: "date_facture",
      align: "center",
      render: (text) => (
        <span>{text ? moment(text).format("DD/MM/YYYY") : "N/A"}</span>
      ),
      sorter: (a, b) => {
        const dateA = a.date_facture ? new Date(a.date_facture) : 0;
        const dateB = b.date_facture ? new Date(b.date_facture) : 0;
        return dateA - dateB;
      },
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Date D'envoi",
      dataIndex: "date_envoi",
      key: "date_envoi",
      align: "center",
      render: (text) => (
        <span>{text ? moment(text).format("DD/MM/YYYY") : ""}</span>
      ),
      sorter: (a, b) => {
        const dateA = a.date_envoi ? new Date(a.date_envoi) : 0;
        const dateB = b.date_envoi ? new Date(b.date_envoi) : 0;
        return dateA - dateB;
      },
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "J retard.",
      dataIndex: "nbjours",
      key: "nbjours",
      align: "center",
      sorter: (a, b) => a.nbjours - b.nbjours,
    },
    {
      title: "Période",
      dataIndex: "periode",
      key: "periode",
      align: "center",
      render: (text) => (
        <span>{text ? moment(text).format("MMM-YYYY") : "N/A"}</span>
      ),
      sorter: (a, b) => {
        const periodA = a.periode ? new Date(a.periode) : 0;
        const periodB = b.periode ? new Date(b.periode) : 0;
        return periodA - periodB;
      },
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Nb. Part.",
      dataIndex: "nb_participants",
      key: "nb_participants",
      align: "right",
      sorter: (a, b) => (a.nb_participants || 0) - (b.nb_participants || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: " Cotisation Patronale.",
      dataIndex: "montant_cotis_pat",
      key: "montant_cotis_pat",
      align: "right",
      render: (text) => (
        <span style={{ paddingRight: "5px" }}>
          {" "}
          <strong>{formatNumber(text || "")}</strong>
        </span>
      ), // Gérer les valeurs null ou undefined
      sorter: (a, b) => (a.montant_cotis_pat || 0) - (b.montant_cotis_pat || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: " Cotisation Salariale.",
      dataIndex: "montant_cotis_sal",
      key: "montant_cotis_sal",
      align: "right",
      render: (text) => (
        <span style={{ paddingRight: "5px" }}>
          {" "}
          <strong>{formatNumber(text || "")}</strong>
        </span>
      ), // Gérer les valeurs null ou undefined
      sorter: (a, b) => (a.montant_cotis_sal || 0) - (b.montant_cotis_sal || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Montant FM",
      dataIndex: "montant_fm",
      key: "montant_fm",
      align: "right",
      render: (text) => (
        <span style={{ paddingRight: "5px" }}>
          {" "}
          <strong>{formatNumber(text || "")}</strong>
        </span>
      ), // Gérer les valeurs null ou undefined
      sorter: (a, b) => (a.montant_fm || 0) - (b.montant_fm || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Montant Adhésion",
      dataIndex: "montant_adh",
      key: "montant_adh",
      align: "right",
      render: (text) => (
        <span style={{ paddingRight: "5px" }}>
          {" "}
          <strong>{formatNumber(text || "")}</strong>
        </span>
      ), // Gérer les valeurs null ou undefined
      sorter: (a, b) => (a.montant_adh || 0) - (b.montant_adh || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Montant Subvention",
      dataIndex: "montant_sub",
      key: "montant_sub",
      align: "right",
      render: (text) => (
        <span style={{ paddingRight: "5px" }}>
          {" "}
          <strong>{formatNumber(text || "")}</strong>
        </span>
      ), // Gérer les valeurs null ou undefined
      sorter: (a, b) => (a.montant_sub || 0) - (b.montant_sub || 0),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Montant Net.Fact",
      dataIndex: "montant_net",
      key: "montant_net",
      align: "right",
      render: (text) => (
        <span style={{ paddingRight: "5px" }}>
          {" "}
          <strong>{formatNumber(text || "")}</strong>
        </span>
      ), // Gérer les valeurs null ou undefined
      sorter: (a, b) => (a.montant_net || 0) - (b.montant_net || 0),
      sortDirections: ["ascend", "descend"],
    },
    ...(selectedOption === "PP" || selectedOption === "CC"
      ? [
        {
          title: "M.P",
          dataIndex: "typereglmt",
          key: "typereglmt",
          align: "center",
          sorter: (a, b) => a.typereglmt.localeCompare(b.typereglmt),
          render: (typereglmt) => {
            let color = "";
            let text = "";

            if (typereglmt === "C") {
              color = "#02b4f0";
              text = "C";
            } else if (typereglmt === "P") {
              color = "#02b4f0";
              text = "P";
            } else if (typereglmt === "T") {
              color = "#02b4f0";
              text = "T";
            } else if (typereglmt === "V") {
              color = "#02b4f0";
              text = "V";
            } else if (typereglmt === "E") {
              color = "#02b4f0";
              text = "E";
            }
            return (
              <div style={{ paddingLeft: 10 }}>
                <Tag color={color} key={typereglmt}>
                  {text}
                </Tag>
              </div>
            );
          },
        },

        {
          title: "Date Reg.",
          dataIndex: "datereglmt",
          key: "datereglmt",
          align: "center",
          sorter: (a, b) => a.datereglmt.localeCompare(b.datereglmt),
          render: (text, record) => (
            <div
              style={{
                whiteSpace: "nowrap",
                textAlign: "center",
                paddingLeft: "5px",
                paddingRight: "5px",
              }}
            >
              {moment(text).locale("fr").format("DD/MM/YYYY")}
            </div>
          ),
        },
        {
          title: "N° C/V",
          dataIndex: "numreglmt",
          key: "numreglmt",
          align: "center",
          sorter: (a, b) => a.numreglmt.localeCompare(b.numreglmt),
        },
        {
          title: "Bque.",
          dataIndex: "codebque",
          key: "codebque",
          align: "center",
          sorter: (a, b) => a.codebque.localeCompare(b.codebque),
        },
      ]
      : []),
    {
      title: "État",
      dataIndex: "etat",
      key: "etat",
      fixed: "right",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => a.etape.localeCompare(b.etape),
      render: (etape) => {
        let color = "";
        let text = "";
        switch (etape) {
          case "pending":
            color = "#b51804";
            text = "En Cours";
            break;
          case "encaisse":
            color = "#e39c02";
            text = "Encaissé";
            break;
          case "validated":
            color = "#059e23";
            text = "Compt.";
            break;

        }
        return (
          <div style={{ paddingLeft: 10 }}>
            <Tag color={color} key={etape}>
              {text}
            </Tag>
          </div>
        );
      },
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      dataIndex: "actions",
      key: "actions",
      align: "center",
      fixed: "right",
      render: (text, record) => (
        <span>
          <Tooltip title="Imprimer">
            <FacturePdf num_facture={record.num_facture} />
          </Tooltip>
          {record.etat === "pending" && (
            <Tooltip title="Modifier">
              <EditOutlined
                style={{ cursor: "pointer", color: "orange", marginRight: 8 }}
                onClick={() => showModal(record)}
              />
            </Tooltip>)}

          {record.etat === "pending" && (
            <Tooltip title="Supprimer">
              <DeleteFilled
                style={{ cursor: "pointer", color: "red" }}
                onClick={() => handleDeleteline(record.num_facture)}
              />
            </Tooltip>
          )}
        </span>
      ),
    },
  ];
  const gestionMenu1 = (
    <Menu>
      <Menu.Item icon={<SyncOutlined />} onClick={handleRefresh} key="1">
        Actualiser
      </Menu.Item>
      <Menu.Item
        icon={<CheckCircleOutlined />}
        // disabled={!isPayingEnabled}
        key="2"
      //   onClick={handleApayerReglement}
      >
        A Encaisser
      </Menu.Item>
      <Menu.Item
        icon={<UndoOutlined />}
        /* disabled={!isAnPayeEnabled}
        onClick={annulerApayerReglement} */
        key="3"
      >
        Annuler A Encaisser
      </Menu.Item>
      <Menu.Item
        icon={<UndoOutlined />}
        /*  onClick={handleAnnulationComptabilisation}
        disabled={!isAnRegEnabled} */
        key="4"
      >
        Annuler Encaissement
      </Menu.Item>
    </Menu>
  );
  const openModal = (typeReglement) => {
    if (selectedRowKeys.length > 0) {
      const selectedRecords = tableData.filter((record) =>
        selectedRowKeys.includes(record.numenreg)
      );

      if (typeReglement === "Chèque") {
        const allSameFournisseur = selectedRecords.every(
          (record) => record.numfourn === selectedRecords[0].numfourn
        );
        if (!allSameFournisseur) {
          notification.warning({
            message: "Sélection invalide",
            description:
              "Veuillez sélectionner des lignes avec le même fournisseur.",
          });
          return;
        }
      }

      const totalMontfact = selectedRecords.reduce((acc, record) => {
        return acc + parseFloat(record.montant_cotis || 0);
      }, 0);

      // Si "Virement", sélectionner l'option "V" et désactiver
      if (typeReglement === "Virement") {
        setSelectedTypeReglement("V");
        setIsTypeRegDisabled(true);
        form.setFieldsValue({
          typeReg: "V",
        });
      } else {
        // Si autre type, réinitialiser le champ et ne pas désactiver
        setSelectedTypeReglement(null);
        setIsTypeRegDisabled(false);
        form.setFieldsValue({
          typeReg: undefined, // Cela réinitialise le Select pour afficher le placeholder
        });
      }

      setModalVisible(true);
      loadParams();
      fetchSaisie();
    } else {
      notification.warning({
        message: "Sélection requise",
        description: "Veuillez sélectionner au moins une ligne.",
      });
    }
  };
  const handleCompteRattacheChange = async (value) => {
    try {
      const soldeData = await reglementService.getSoldeReg(value);
      setSolde(soldeData);
    } catch (error) {
      console.error("Erreur lors de la récupération du solde :", error);
    }
  };

  const menu = (
    <Menu
      onClick={(e) => {
        // Appelle openModal avec le type de règlement sélectionné
        openModal(e.key);
      }}
    >
      <Menu.Item key="Virement">Virement</Menu.Item>
      <Menu.Item key="Chèque">Chèque</Menu.Item>
    </Menu>
  );
  useEffect(() => {
    if (selectedRowKeys.length > 0) {
      // Récupérer les num_facture sélectionnés
      const selectedFactures = selectedRowKeys.join(" - ");

      // Récupérer la société de la première facture sélectionnée
      const firstSelectedRecord = tableData.find(
        (record) => record.num_facture === selectedRowKeys[0]
      );
      const societe = firstSelectedRecord
        ? firstSelectedRecord.societe
        : "Aucune";

      // Mettre à jour le champ `libReg`
      form.setFieldsValue({
        libReg: `Encaissement N° ${selectedFactures} / ${societe}`,
      });
    } else {
      // Réinitialiser si aucune ligne sélectionnée
      form.setFieldsValue({ libReg: "" });
    }
  }, [selectedRowKeys, tableData]);

  return (
    <div>
      <Card>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: "16px" }}
        >
          <Col>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 20px",
                background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                borderRadius: 10,
                boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
                marginBottom: 16,
              }}
            >
              <FileTextOutlined style={{ fontSize: 22, color: "#fff" }} />
              <span
                style={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: "#fff",
                  letterSpacing: 0.5,
                  margin: 0,
                }}
              >
                Factures Adhérents
              </span>
            </div>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Exercice</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 120,
                  marginRight: 10,
                  "--select-accent": "#1890ff",
                  "--select-accent-bg": "#e6f4ff",
                  "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                }}
                onChange={handleYearChange}
                value={selectedYear}
              >
                {years.map((year) => (
                  <Option key={year} value={year}>
                    {year}
                  </Option>
                ))}
              </Select>
            </Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Mois</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 140,
                  marginRight: 10,
                  "--select-accent": "#722ed1",
                  "--select-accent-bg": "#f9f0ff",
                  "--select-accent-shadow": "rgba(114, 46, 209, 0.25)",
                }}
                onChange={handleMonthChange}
                value={selectedMonth}
              >
                {months.map((month) => (
                  <Option key={month.value} value={month.value}>
                    {month.label}
                  </Option>
                ))}
              </Select>
            </Space>
            <Space direction="vertical" style={{ textAlign: "left" }}>
              <label>Adhérent</label>
              <Select
                className="select-colored-accent"
                style={{
                  width: 300,
                  "--select-accent": "#52c41a",
                  "--select-accent-bg": "#f6ffed",
                  "--select-accent-shadow": "rgba(82, 196, 26, 0.25)",
                }}
                value={selectAdherent}
                onChange={onchangeAdhenrent}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                <Option value="">Toutes les Sociétés</Option>
                {adherents.map((adherent) => (
                  <Option key={adherent.codeadht} value={adherent.codeadht}>
                    {`${adherent.codeadht} - ${adherent.intitule}`}
                  </Option>
                ))}
              </Select>
            </Space>
          </Col>

          <Col>
            <Input
              className="search-input-highlight"
              placeholder="Rechercher..."
              allowClear
              prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
              style={{ width: 250, marginRight: 10 }}
              onChange={(e) => handleSearch(e.target.value)}
            />

            <Button
              className="buttonRecep"
              icon={<PlusOutlined />}
              style={{ marginRight: 10 }}
              onClick={() => showModal()}
            >
              Ajouter
            </Button>

            <Button
              className="buttonExport"
              onClick={exportToExcel}
              style={{ marginRight: 10 }}
            >
              {" "}
              Export Excel
            </Button>
            <Button
              className="buttonRefresh"
              icon={<SyncOutlined />}
              onClick={handleRefresh}
            ></Button>
          </Col>
        </Row>

        {/*  <Row justify="end">
                <Col span={24} style={{ textAlign: "right" }}>
                  <Radio.Group
                    value={selectedOption}
                    
                    onChange={handleOptionChange}
                    style={{ marginBottom: "1rem" }}
                  >
                    <Radio.Button
                      value="TT"
                      style={{
                        backgroundColor:
                          selectedOption === "TT" ? "#153508" : "#fff",
                        color: selectedOption === "TT" ? "#fff" : "#153508",
                      }}
                    >
                      Tout
                    </Radio.Button>
                    <Radio.Button
                      value="NP"
                      style={{
                        backgroundColor:
                          selectedOption === "NP" ? "#153508" : "#fff",
                        color: selectedOption === "NP" ? "#fff" : "#153508",
                      }}
                    >
                      Non Échue
                    </Radio.Button>
                    <Radio.Button
                      value="AP"
                      style={{
                        backgroundColor:
                          selectedOption === "AP" ? "red" : "#fff",
                        color: selectedOption === "AP" ? "#fff" : "#153508",
                      }}
                    >
                      Échue
                    </Radio.Button>
                    <Radio.Button
                      value="PP"
                      style={{
                        backgroundColor:
                          selectedOption === "PP" ? "#153508" : "#fff",
                        color: selectedOption === "PP" ? "#fff" : "#153508",
                      }}
                    >
                      Encaissée
                    </Radio.Button>
                    <Radio.Button
                      value="CC"
                      style={{
                        backgroundColor:
                          selectedOption === "CC" ? "#153508" : "#fff",
                        color: selectedOption === "CC" ? "#fff" : "#153508",
                      }}
                    >
                      Comptabilisée
                    </Radio.Button>
                  
                  </Radio.Group>
                </Col>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Space
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
               
                    <Dropdown overlay={menu} disabled={!isRgFactEnabled}>
                      <Button className="buttonRegle">
                        Encaissement Facture(s) <DownOutlined />
                      </Button>
                    </Dropdown>

                    <Button
                      icon={<CalculatorOutlined />}
                      className="buttonCompta"
                      disabled={!isComptaEnabled}
                    
                    >
                      Comptabiliser
                    </Button>
                    <Dropdown  overlay={gestionMenu1} trigger={["click"]}>
                      <Button
                        icon={<MoreOutlined />}
                       
                      />
                    </Dropdown>
                  </Space>
                </Col>
              </Row> */}

        <Table
          scroll={{
            x: true,
          }}
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          //  className="custom-header1-table"
          bordered
          dataSource={filteredData}
          rowSelection={rowSelection}
          rowKey={(record) => record.num_facture}
          rowClassName={(record) =>
            selectedRowKeys.includes(record.num_facture) ? "selected-row" : ""
          }
          //  className="custom-header2-table"
          className="custom-header2-table my-custom-table"
          pagination={{
            pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
            showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
            pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
            onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
          }}
          loading={loading}
          columns={columns}
          showSorterTooltip={false}
        />
        <Modal
          style={{
            top: 20,
          }}
          //title="Ajouter Facture"
          title={
            <div>
              {currentFacture ? "Modification Facture" : "Ajout Facture"}
            </div>
          }
          open={isModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          footer={null}
        >
          <Form onFinish={onFinish} layout="vertical" form={form}>
            <Form.Item
              label="Société"
              name="codesoc"
              rules={[
                { required: true, message: "Veuillez saisir la société!" },
              ]}
            >
              <Select
                style={{ width: "100%" }}
                defaultValue={"--Selectionner--"}
                showSearch
              >
                {adherents.map((adherent) => (
                  <Option key={adherent.codeadht} value={adherent.codeadht}>
                    {`${adherent.codeadht} - ${adherent.intitule}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Date facture"
                  name="date_facture"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez sélectionner la date de la facture!",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    format="DD/MM/YYYY"
                    disabledDate={(current) => current && current > dayjs().endOf('day')}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Date envoi"
                  name="date_envoi"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez sélectionner la date de la facture!",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    format="DD/MM/YYYY"
                    disabledDate={(current) => current && current > dayjs().endOf('day')}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  initialValue={0}
                  label="Cotisation Patronale"
                  name="montant_cotis_pat"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir le montant de la cotisation!",
                    },
                  ]}
                >
                  <Input type="number" onChange={calculateMontantNet} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  initialValue={0}
                  label="Cotisation Salariale"
                  name="montant_cotis_sal"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir le montant de la cotisation!",
                    },
                  ]}
                >
                  <Input type="number" onChange={calculateMontantNet} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              {/*   <Col span={12}> */}
              {/*  <Form.Item
                  label="Autres"
                  name="autre"
                 
                >
                  <Input />
                </Form.Item> 
               </Col> */}
              <Col span={12}>
                <Form.Item
                  initialValue={0}
                  label="Montant Frais Mdx"
                  name="montant_fm"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez saisir le montant des frais MDX!",
                    },
                  ]}
                >
                  <Input type="number" onChange={calculateMontantNet} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  initialValue={0}
                  label="Montant Adhésion"
                  name="montant_adh"
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    onChange={calculateMontantNet}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  initialValue={0}
                  label="Montant Subvention"
                  name="montant_sub"
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    onChange={calculateMontantNet}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Nb. Participants"
                  name="nb_participants"
                /*  rules={[
                  {
                    required: true,
                    message: "Veuillez saisir le nombre de participants!",
                  },
                ]} */
                >
                  <Input type="number" style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Période"
                  name="periode"
                  rules={[
                    { required: true, message: "Veuillez saisir la période!" },
                  ]}
                >
                  <DatePicker
                    format="MMM-YYYY"
                    picker="month"
                    disabledDate={(current) => current && current > dayjs().endOf('day')}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              {/* <Col span={24}>
    <Form.Item
      label="Montant Net Facture"
      name="montant_net"
    >
      <InputNumber style={{ width: "100%" }} readOnly />
    </Form.Item>
  </Col> */}
              <Col span={24}>
                <div style={{ fontWeight: "bold", fontSize: "16px" }}>
                  Montant Net Facture : {formatNumber(montantNet)} FCFA
                </div>
              </Col>
            </Row>
            <div style={{ marginTop: "20px", textAlign: "right" }}>
              <Form.Item>
                <Button onClick={handleCancel} type="dashed" danger>
                  Annuler
                </Button>
                <Button
                  htmlType="submit"
                  type="primary"
                  style={{ backgroundColor: "#010f1c", marginLeft: 8 }}
                >
                  Valider
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Modal>
      </Card>
      <DraggableModal
        title={
          isEditMode
            ? "Modification Encaissement Facture Fournisseur de Soins"
            : "Encaissement Facture Fournisseur de Soins"
        }
        open={modalVisible}
        maskClosable={false}
        onCancel={handleModalCancel}
        onOk={handleModalOk}
        style={{ top: 20 }}
        width={1000}
      >
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name="typeReg"
                label="Type Règlement"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un type de règlement",
                  },
                ]}
              >
                <Select
                  placeholder="- Sélectionner -"
                  onChange={handleTypeReglementChange}
                  value={selectedTypeReglement}
                  disabled={isTypeRegDisabled} // Désactive si "Virement" est sélectionné
                >
                  <Option value="V">Virement</Option>
                  <Option value="C">Chèque</Option>
                  <Option value="Compte">Compte Avance</Option>
                  <Option value="E">Espèce</Option>
                  <Option value="T">Transfert</Option>
                </Select>
              </Form.Item>
            </Col>
            {(selectedTypeReglement === "V" ||
              selectedTypeReglement === "C") && (
                <Form.Item
                  name="comptegen"
                  label="Banque"
                  rules={[
                    {
                      required: true,
                      message: "Veuillez sélectionner un type de règlement",
                    },
                  ]}
                >
                  <Select
                    style={{ width: 180 }}
                    onChange={handleCompteRattacheChange}
                  >
                    {journalRegData &&
                      journalRegData
                        .filter((journal) => journal.type === "BANQUE")
                        .map((journal) => (
                          <Option
                            key={journal.compte_rattache}
                            value={journal.compte_rattache}
                          >
                            {` ${journal.libelle}`}
                          </Option>
                        ))}
                  </Select>
                </Form.Item>
              )}
            {selectedTypeReglement === "Compte" && (
              <Form.Item
                label="Compte Avance"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un type de règlement",
                  },
                ]}
              >
                <Select
                  style={{ width: 180 }}
                  onChange={handleCompteRattacheChange}
                >
                  {journalRegData &&
                    journalRegData
                      .filter((journal) => journal.type === "")
                      .map((journal) => (
                        <Option key={journal.codej} value={journal.codej}>
                          {`${journal.libelle}`}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            )}
            {selectedTypeReglement === "T" && (
              <Form.Item
                label="Transfert"
                name="comptegen"
                rules={[
                  {
                    required: true,
                    message: "Veuillez sélectionner un type de règlement",
                  },
                ]}
              >
                <Select
                  style={{ width: 180 }}
                  onChange={handleCompteRattacheChange}
                >
                  {journalRegData &&
                    journalRegData
                      .filter((journal) => journal.type === "TRANSFERT")
                      .map((journal) => (
                        <Option
                          key={journal.compte_rattache}
                          value={journal.compte_rattache}
                        >
                          {`${journal.libelle}`}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            )}

            <Col span={6}>
              <Form.Item
                name="numReg"
                label={`N° ${selectedTypeReglement
                  ? typeReglementLabels[selectedTypeReglement]
                  : ""
                  }`}
                rules={[
                  { required: true, message: "Numéro de facture requis" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="dateReg"
                label="Date Règlement"
                initialValue={dayjs()}
                rules={[
                  { required: true, message: "Date de règlement requise" },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="DD/MM/YYYY"
                  disabledDate={(current) => current && current > dayjs().endOf('day')}
                />
              </Form.Item>

              <Row gutter={16}>
                <Col span={24}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "16px",
                    }}
                  >
                    <span>
                      <strong>Montant(s) facture(s): </strong>
                      {formatNumber(
                        tableData
                          .filter((record) =>
                            selectedRowKeys.includes(record.num_facture)
                          )
                          .reduce(
                            (acc, record) => acc + (record.montant_cotis || 0),
                            0
                          )
                      )}{" "}
                      FCFA
                    </span>

                    {/* {!isEditMode && ( )} */}
                    <span>
                      <strong>Solde Banque ce jour: </strong>
                      <strong color="#59e60e">{solde.solde || 0}</strong>
                    </span>
                  </div>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Row gutter={16}>
                    <Col span={20}>
                      <Form.Item name="datetrait" label="Mois traitement">
                        <Input
                          value={selectedDate}
                          style={{ width: "100%" }}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <div style={{ paddingTop: "30px" }}>
                        <Popover
                          placement="bottomCenter"
                          content={
                            <DatePicker
                              format="MMM-YYYY"
                              picker="month"
                              value={selectedDate}
                              onChange={(date) => setSelectedDate(date)}
                              disabledDate={(current) => current && current > dayjs().endOf('day')}
                            />
                          }
                          trigger="click"
                        >
                          <Button icon={<CalendarOutlined />} />
                        </Popover>
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col span={12}>
                  {/*   <Row gutter={16}>
                 
                    <Col span={8}  style={{ marginBottom: 16 }}> */}
                  <Space direction="vertical" style={{ textAlign: "left" }}>
                    <strong>
                      Facture N°
                      {selectedRowKeys.length > 1
                        ? selectedRowKeys.join(" - ")
                        : selectedRowKeys[0] || "Aucune"}
                    </strong>
                    <InputNumber
                      style={{ width: "150px" }}
                      value={tableData
                        .filter((record) =>
                          selectedRowKeys.includes(record.num_facture)
                        )
                        .reduce(
                          (acc, record) => acc + (record.montant_cotis || 0),
                          0
                        )}
                      readOnly
                    />
                  </Space>

                  {/*  </Col>
                 
                </Row> */}
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    name="libReg"
                    label="Libellé"
                    rules={[
                      { required: true, message: "Veuillez entrer un libellé" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </DraggableModal>
    </div>
  );
};

export default FactureAdht;
